/* ip代理 */
import {action, computed, observable,} from 'mobx';
import {deviceVasIPOpen, deviceVasIPClose, deviceVasIPChange} from '@/services/Home';
import DeviceStore from '@/stores/device';
import * as R from 'ramda';
import {message} from 'antd';
import UserStore from '@/stores/user';
import log from '@/utils/log';

class VasIpProxyStore {
  
  @observable activeKeyId: number | undefined
  
  @computed get selectedIds() {
    return DeviceStore.DeviceBaseStore.selectedCids.map(cid =>
      R.find(R.propEq('cid', cid))(DeviceStore.DeviceBaseStore.deviceList
      )).map((r: any) => r.id);
  }
  
  @action.bound async open () {
    
    const ids = this.selectedIds
    
    const [error] = await deviceVasIPOpen({
      ids: R.join(',', ids),
      groupId: UserStore.GroupStore.activeGroupId
    });
    
    if(error) {
      log({ pageId: 'P30', eventId: 'E3001',  ext: ''})
      return false;
    }
    log({ pageId: 'P30', eventId: 'E3000',  ext: ''})
  
    message.success('操作成功')
  
    await this.update()
  
    return true
    
  }
  
  @action.bound async change () {
    
    const ids =  this.selectedIds;
    
    const [error] = await deviceVasIPChange({
      ids: R.join(',', ids),
      groupId: UserStore.GroupStore.activeGroupId
    });
  
    if(error) {
      log({ pageId: 'P30', eventId: 'E3003',  ext: ''})
      return false;
    }
    log({ pageId: 'P30', eventId: 'E3002',  ext: ''})
    
    message.success('操作成功')
  
    await this.update()
  
    return true
    
  }
  
  @action.bound async close () {
    
    const ids =  this.selectedIds;
    
    const [error] = await deviceVasIPClose({
      ids: R.join(',', ids),
      groupId: UserStore.GroupStore.activeGroupId
    });
  
    if(error) {
      log({ pageId: 'P30', eventId: 'E3005',  ext: ''})
      return false;
    }
    log({ pageId: 'P30', eventId: 'E3004',  ext: ''})
    
    message.success('操作成功')
  
    await this.update()
  
    return true
    
  }
  
  @action.bound setActiveKey (id: number) {
    this.activeKeyId = id;
  }
  
  @action.bound  async update () {
    await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
    setTimeout(async () => {
      await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
    },1500)
  }
  
}

export default VasIpProxyStore;
